import localhost from "../../../apis/localhost";
import { selectIsSharepointAuthenticated } from "../selectors";
import {
  setAuthorizationPolicy,
  setAuthPending,
  setIsSharepointAuthorized,
  setSharepointAuthUrl,
  setSharepointError,
  setSharepointLoading,
} from "../sharepointSlice";
import {
  authorizationPolicyOf,
  beginAuthRequest,
  isCurrentAuthRequest,
} from "./utils";

export const authenticateSharepoint =
  ({ forcePrompt = false } = {}) =>
  async (dispatch, getState) => {
    const requestId = beginAuthRequest(dispatch, getState);
    const wasAuthorized = selectIsSharepointAuthenticated(getState());
    dispatch(setAuthPending(true));
    dispatch(setAuthorizationPolicy(null));
    try {
      const returnUrl = encodeURIComponent(window.location.href);
      const response = await localhost.get(
        `/sharepoint/authorization?returnUrl=${returnUrl}`
      );
      if (!isCurrentAuthRequest(getState, requestId)) {
        return;
      }

      if (response.status !== 200) {
        throw new Error(
          `Error signing in to Sharepoint failed: ${response.statusText}`
        );
      }

      dispatch(setAuthorizationPolicy(authorizationPolicyOf(response.data)));
      if (response.data.isAuthenticated && !forcePrompt) {
        if (!wasAuthorized) {
          dispatch(setSharepointLoading(true));
        }
        dispatch(setIsSharepointAuthorized(true));
      } else {
        dispatch(setIsSharepointAuthorized(false));
        dispatch(setSharepointAuthUrl(response.data.url));
        dispatch(setSharepointLoading(false));
      }
    } catch (error) {
      if (!isCurrentAuthRequest(getState, requestId)) {
        return;
      }
      dispatch(setSharepointError(error));
      dispatch(setSharepointLoading(false));
    } finally {
      if (isCurrentAuthRequest(getState, requestId)) {
        dispatch(setAuthPending(false));
      }
    }
  };
